import React, { useState } from 'react';
import { toast } from 'sonner';
import { FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon, CreditCardIcon, ChevronDownIcon, ChevronUpIcon, WalletIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  const [quickLinksOpen, setQuickLinksOpen] = useState(false);
  const [customerServiceOpen, setCustomerServiceOpen] = useState(false);
  const [shopByCategoryOpen, setShopByCategoryOpen] = useState(false);
  return <footer className="hidden md:block bg-white border-t border-gray-200 mt-8" data-id="element-2605" data-mp="3s140y6vesuzr">
      {/* Assistance Section (Replaces Newsletter) */}
      <div className="bg-[#f0f7ff] border-b border-gray-200" data-id="element-2606" data-mp="3j1z20zfxqzn2">
        <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2607" data-mp="3j3jwyq65wklg">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-2608" data-mp="3e35ml1h38yk9">
            {/* Left side: Text */}
            <div className="text-center lg:text-left" data-id="element-2609" data-mp="394b5c3yrri29">
              <h2 className="text-lg md:text-2xl font-bold text-[#1E2B55] mb-1 md:mb-2" data-id="element-2610" data-mp="2kcl2p6svuhv4">
                Need Assistance? We're Here to Help!
              </h2>
              <p className="text-gray-600 text-xs md:text-base max-w-2xl" data-id="element-2611" data-mp="2p5xsvld7mwpz">
                Have questions or need support? Our team is just a call or chat
                away. Reach out to us anytime for quick and friendly assistance.
              </p>
            </div>

            {/* Right side: Contact buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 w-full sm:w-auto" data-id="element-2612" data-mp="382p4r9qfa9k0">
              {/* Phone Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2613" data-mp="2u1uyoxqukkoi">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2614" data-mp="1io0ylq8fdnuf">
                  <PhoneIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2615" data-mp="1no5fhhd8wkl6" />
                </div>
                <div className="flex flex-col" data-id="element-2616" data-mp="13jy18b8344c0">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2617" data-mp="zimcs90y5p5e">
                    Got Question? Call us 24/7
                  </span>
                  <a href="tel:043441122" className="text-base md:text-lg font-bold text-[#0066CC] hover:underline" data-id="element-2618" data-mp="ptcjipuda0fp">
                    043441122
                  </a>
                </div>
              </div>

              {/* Chat Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2619" data-mp="btjsetexhi77">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2620" data-mp="6wjp2q9gqtjs">
                  <MailIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2621" data-mp="21888b4mq9i9z" />
                </div>
                <div className="flex flex-col" data-id="element-2622" data-mp="28ssjis54ceni">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2623" data-mp="28pwlz4x6nrzl">
                    24/7 chat support
                  </span>
                  <button onClick={() => window.openAuthModal?.()} className="text-base md:text-lg font-bold text-[#0066CC] hover:underline text-left" data-id="element-2624" data-mp="2ij50kadq5pow">
                    Chat with Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2625" data-mp="1zqjcwdcz15fe">
        {/* Mobile: Brand Block (Reduced - No Contact Info) */}
        <div className="md:hidden mb-4" data-id="element-2626" data-mp="23qthbll47ns5">
          <img src="https://cdn.magicpatterns.com/uploads/enT9iVMZr5bUJi1w413sX2/Layer_1_(1).png" alt="Dawaak" className="h-8 mb-3 w-auto" data-id="element-2627" data-mp="3b70xng77hjm7" />
          <p className="text-xs text-gray-600 mb-3 line-clamp-2" data-id="element-2628" data-mp="3dqnruugbprzt">
            Your trusted source for premium healthcare products and pharmacy
            services.
          </p>
          <div className="flex space-x-2 mb-4" data-id="element-2629" data-mp="38u76u94f7tqy">
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2630" data-mp="3nq4v7583rtsm">
              <FacebookIcon className="w-3.5 h-3.5" data-id="element-2631" data-mp="kdx4tackqvc" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2632" data-mp="iksfjjaogpz">
              <InstagramIcon className="w-3.5 h-3.5" data-id="element-2633" data-mp="aagrawt7gav9" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2634" data-mp="5b41c371enog">
              <TwitterIcon className="w-3.5 h-3.5" data-id="element-2635" data-mp="jbetd9k328b7" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2636" data-mp="fa33r417ln30">
              <YoutubeIcon className="w-3.5 h-3.5" data-id="element-2637" data-mp="xvrf7afm0xac" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2638" data-mp="12w5d3znhyqun">
              <LinkedinIcon className="w-3.5 h-3.5" data-id="element-2639" data-mp="tvh7ntc65ytd" />
            </a>
          </div>
        </div>
        {/* Mobile: Collapsible Sections (Removed as per request) */}
        {/* Desktop: Grid Layout */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] gap-6 md:gap-8" data-id="element-2640" data-mp="jycgtg7dpf68">
          {/* Column 1: About */}
          <div className="lg:col-span-1" data-id="element-2641" data-mp="67za1h6846ih">
            <img src="https://cdn.magicpatterns.com/uploads/enT9iVMZr5bUJi1w413sX2/Layer_1_(1).png" alt="Dawaak" className="h-10 mb-4 w-auto" data-id="element-2642" data-mp="a7qakcljy107" />
            <p className="text-sm text-gray-600 mb-4" data-id="element-2643" data-mp="171wxj02m2nu">
              Your trusted source for premium healthcare products and pharmacy
              services.
            </p>
            <div className="flex space-x-3 mb-6" data-id="element-2644" data-mp="22yll8ctma6t0">
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2645" data-mp="1y5ira3kxgvca">
                <FacebookIcon className="w-4 h-4" data-id="element-2646" data-mp="1p52pcyju1w9j" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2647" data-mp="1p6x7y67mtcag">
                <InstagramIcon className="w-4 h-4" data-id="element-2648" data-mp="2hut499tah26p" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2649" data-mp="2cuet3iwe5c4g">
                <TwitterIcon className="w-4 h-4" data-id="element-2650" data-mp="27vbwmmuh8e83" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2651" data-mp="11gjce5pu8vb4">
                <YoutubeIcon className="w-4 h-4" data-id="element-2652" data-mp="mcqdl2olyra0" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2653" data-mp="madnu3clzcme">
                <LinkedinIcon className="w-4 h-4" data-id="element-2654" data-mp="w9mmvambzhfm" />
              </a>
            </div>
            <div className="space-y-2" data-id="element-2655" data-mp="111miwrza5q6x">
              <div className="flex items-start" data-id="element-2656" data-mp="112paz38c9yof">
                <MapPinIcon className="w-4 h-4 text-[#1E2B55] mt-0.5 mr-2 flex-shrink-0" data-id="element-2657" data-mp="153hmy48lihoe" />
                <p className="text-xs text-gray-600" data-id="element-2658" data-mp="1a1jeldk37pbh">
                  Riyadh, Kingdom of Saudi Arabia
                </p>
              </div>
              <div className="flex items-center" data-id="element-2659" data-mp="1f1oww34gvzgw">
                <PhoneIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2660" data-mp="1jzytmi5ub84m" />
                <p className="text-xs text-gray-600" data-id="element-2661" data-mp="3gsiip851tcxc">+966 11 123 4567</p>
              </div>
              <div className="flex items-center" data-id="element-2662" data-mp="3guv989ovgvm0">
                <MailIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2663" data-mp="3lsmz6y5yi7nk" />
                <p className="text-xs text-gray-600" data-id="element-2664" data-mp="1rj87anldpszh">
                  support@innovapharmacy.com
                </p>
              </div>
            </div>
          </div>
          {/* Column 2: Shop by Category */}
          <div data-id="element-2665" data-mp="218jbpwxbm9h1">
            <h3 className="text-base font-semibold mb-4" data-id="element-2666" data-mp="2191g5gu4zu01">Shop by Category</h3>
            <ul className="space-y-2" data-id="element-2667" data-mp="1wbj43hktoynt">
              <li data-id="element-2668" data-mp="1wckr8kf45blw">
                <a href="/category/prescription-medicines" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2669" data-mp="18kvu8qrcjyym">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2670" data-mp="13o5ek4jgf5dq" />
                  Prescription Medicines
                </a>
              </li>
              <li data-id="element-2671" data-mp="1dix9t1pkdg5c">
                <a href="/category/vitamins-supplements" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2672" data-mp="1dif9ntzs6hs5">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2673" data-mp="2oydko3eirdw0" />
                  Vitamins & Supplements
                </a>
              </li>
              <li data-id="element-2674" data-mp="31hraxnrui9bt">
                <a href="/category/personal-care" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2675" data-mp="31ianeoyq85ig">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2676" data-mp="2rjla79hrz98j" />
                  Personal Care
                </a>
              </li>
              <li data-id="element-2677" data-mp="3fagz9yuujqc3">
                <a href="/category/mother-baby" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2678" data-mp="3f9xs9d6qimcu">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2679" data-mp="35il16nsrg07v" />
                  Mother & Baby
                </a>
              </li>
              <li data-id="element-2680" data-mp="3ag349xk3jl7y">
                <a href="/category/medical-devices" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2681" data-mp="22vzzvnlpdfg">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2682" data-mp="shhsfjkleie2" />
                  Medical Devices
                </a>
              </li>
              <li data-id="element-2683" data-mp="wi1loc21p1ux">
                <a href="/category/health-wellness" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2684" data-mp="wijk9fc6js60">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2685" data-mp="nh3ifvzfkyde" />
                  Health & Wellness
                </a>
              </li>
              <li data-id="element-2686" data-mp="dk777ii5dy55">
                <a href="/category/beauty-skincare" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2687" data-mp="dkqpx1fmgqk8">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2688" data-mp="4rwwm03cbqnd" />
                  Beauty & Skincare
                </a>
              </li>
              <li data-id="element-2689" data-mp="3m1bs9zdr0led">
                <a href="/categories" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2690" data-mp="3m0sjp99zn9d0">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2691" data-mp="37ed2e8ujhz1r" />
                  View All Categories
                </a>
              </li>
            </ul>
          </div>
          {/* Column 3: Quick Links */}
          <div data-id="element-2692" data-mp="3hd2mm89wrvl6">
            <h3 className="text-base font-semibold mb-4" data-id="element-2693" data-mp="3h9eqr2gzqx3a">Quick Links</h3>
            <ul className="space-y-2" data-id="element-2694" data-mp="3cbn1kg7qdp2s">
              <li data-id="element-2695" data-mp="3cerblu7vnf1d">
                <a href="/account" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2696" data-mp="3qbxtlmks19pj">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2697" data-mp="3m8hy4tkg1fef" />
                  My Account
                </a>
              </li>
              <li data-id="element-2698" data-mp="3v2e716olkvbw">
                <a href="/account/orders" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2699" data-mp="3v3xoh0lzpcf9">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2700" data-mp="8vy2puq1nedj" />
                  Orders & Tracking
                </a>
              </li>
              <li data-id="element-2701" data-mp="g0h2sh7ea88k">
                <a href="/account/wishlist" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2702" data-mp="fwt9nj5v3nud">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2703" data-mp="pvhcvbt6tye0" />
                  Wishlist
                </a>
              </li>
              <li data-id="element-2704" data-mp="zmvje3jk3ygn">
                <a href="/cart" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2705" data-mp="zneouks0suds">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2706" data-mp="13qjrqog0iy2y" />
                  Shopping Cart
                </a>
              </li>
              <li data-id="element-2707" data-mp="1dn67iytheyy4">
                <a href="/store-locator" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2708" data-mp="1dlbojq1rtgwo">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2709" data-mp="3fdhq2n8zgxx5" />
                  Store Locator
                </a>
              </li>
              <li data-id="element-2710" data-mp="37w1o4biwznh5">
                <a href="/brands" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2711" data-mp="37wl8dyw1enyc">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2712" data-mp="2y5gtez6d333i" />
                  Shop by Brand
                </a>
              </li>
              <li data-id="element-2713" data-mp="2t3rgtf3hqhdb">
                <a href="/offers" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2714" data-mp="3qt2vg2zxxzo9">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2715" data-mp="3ls6t3tv8mlky" />
                  Deals & Offers
                </a>
              </li>
              <li data-id="element-2716" data-mp="3bwlmfif84x4v">
                <a href="/about-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2717" data-mp="3bv27bv5b0s4o">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2718" data-mp="20h6pufqxg7aa" />
                  About Us
                </a>
              </li>
            </ul>
          </div>
          {/* Column 4: Customer Service */}
          <div data-id="element-2719" data-mp="3u22srmgvz9o2">
            <h3 className="text-base font-semibold mb-4" data-id="element-2720" data-mp="3u2w0apno6379">Customer Service</h3>
            <ul className="space-y-2" data-id="element-2721" data-mp="3fdgd1jnckfwb">
              <li data-id="element-2722" data-mp="3fehnpn0gb0di">
                <a href="/help-center" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2723" data-mp="3fatz929v545n">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2724" data-mp="bxj1p7dg91we" />
                  Help Center
                </a>
              </li>
              <li data-id="element-2725" data-mp="1y1z4ythv44n">
                <a href="/faq" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2726" data-mp="1yjqpi57ou68">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2727" data-mp="6z7tt26pt1gt" />
                  FAQ
                </a>
              </li>
              <li data-id="element-2728" data-mp="2rn3uzfye12s0">
                <a href="/contact-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2729" data-mp="2rnm0l36xwtcl">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2730" data-mp="14qmkaclmuwam" />
                  Contact Us
                </a>
              </li>
              <li data-id="element-2731" data-mp="1ipdsjidtdnqu">
                <a href="/track-order" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2732" data-mp="1ipm9pmgyzf7u">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2733" data-mp="qyg1sjv0cd80" />
                  Track My Order
                </a>
              </li>
              <li data-id="element-2734" data-mp="ly1wvaopdje7">
                <a href="/shipping-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2735" data-mp="zrjf8s5nkq2n">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2736" data-mp="uzjh9595878p" />
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-2737" data-mp="3a6oy7fruzt0">
                <a href="/return-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2738" data-mp="38lvym93vox9">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2739" data-mp="27d8a4tv53hav" />
                  Returns & Refunds
                </a>
              </li>
              <li data-id="element-2740" data-mp="2c4q9xelffbu9">
                <a href="/terms-conditions" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2741" data-mp="2c6b24xk9qioy">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2742" data-mp="1jh3vtcekoot5" />
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-2743" data-mp="1te07fqzrpr1x">
                <a href="/privacy-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2744" data-mp="1tdgyv0w0cf0k">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2745" data-mp="34svua08kiytk" />
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-2746" data-mp="39qnmywh1eoyt">
                <a href="/report-issue" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2747" data-mp="39q5i5bgb72fa">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2748" data-mp="t6lbr6kk7vax" />
                  Report an Issue
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Payment Methods & Copyright - Desktop Only */}
        <div className="hidden md:block mt-10 pt-6 border-t border-gray-200" data-id="element-2749" data-mp="jdwdjde0sdxj">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2750" data-mp="ehywt5yuh5k8">
            <div className="w-full md:w-auto" data-id="element-2751" data-mp="adhfrejvd6d5">
              <h4 className="text-sm font-semibold mb-2 flex items-center justify-center md:justify-start" data-id="element-2752" data-mp="5fpn2ibehg7w">
                <CreditCardIcon className="w-4 h-4 mr-2 text-[#1E2B55]" data-id="element-2753" data-mp="hed87l3v5po" />
                Payment Methods
              </h4>
              <div className="flex items-center justify-center md:justify-start space-x-3 flex-wrap gap-y-2" data-id="element-2754" data-mp="1zsxnqqm24m1g">
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/visa.svg?v=2.1.18" alt="Visa" className="h-8 w-auto" data-id="element-2755" data-mp="1uw74xvivbccc" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/master-card.svg?v=2.1.18" alt="Mastercard" className="h-8 w-auto" data-id="element-2756" data-mp="18nbkge9jk9oo" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/mada.svg?v=2.1.18" alt="Mada" className="h-8 w-auto" data-id="element-2757" data-mp="yx0deiuk9kdk" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/stc-pay.svg?v=2.1.18" alt="STC Pay" className="h-8 w-auto" data-id="element-2758" data-mp="pzpymnijbd3w" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/apple-pay.svg?v=2.1.18" alt="Apple Pay" className="h-8 w-auto" data-id="element-2759" data-mp="g07iki5qwbh4" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/tamara.svg?v=2.1.18" alt="Tamara" className="h-8 w-auto" data-id="element-2760" data-mp="2abw1evf3ky6s" />
              </div>
            </div>
            <div className="flex flex-col items-center md:items-end gap-2" data-id="element-2761" data-mp="8gyb4ugsumup">
              <div className="flex items-center gap-3 text-xs text-gray-600" data-id="element-2762" data-mp="3pq0jv3qgvfy">
                <div className="flex items-center gap-1.5" data-id="element-2763" data-mp="3nn0ei8v9lxi">
                  <GlobeIcon className="w-3.5 h-3.5 text-[#1E2B55]" data-id="element-2764" data-mp="hg38vykjec5t" />
                  <span data-id="element-2765" data-mp="dft24jox7hpw">Saudi Arabia (SAR)</span>
                </div>
                <span className="text-gray-300" data-id="element-2766" data-mp="dhlxv3xzwhj4">|</span>
                <a href="/en" className="hover:text-[#1E2B55] transition-colors font-medium" aria-current="true" data-id="element-2767" data-mp="re98g9ivf67i">
                  English
                </a>
                <span className="text-gray-300" data-id="element-2768" data-mp="2t6xgqxadgju5">·</span>
                <a href="/" className="hover:text-[#1E2B55] transition-colors" data-id="element-2769" data-mp="2o8ds2p4e8ty3">
                  Arabic
                </a>
              </div>
              <p className="text-sm text-gray-600 text-center md:text-right" data-id="element-2770" data-mp="jp6ypyugr6lz">
                &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
        {/* Copyright - Mobile Only */}
        <div className="md:hidden mt-4 pt-4 border-t border-gray-200" data-id="element-2771" data-mp="oi9tgaaz8m3r">
          <p className="text-xs text-gray-600 text-center" data-id="element-2772" data-mp="rdumt83sqn0">
            &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}